"use client";

import { ArrowRight, Gem, Syringe, CircleDot } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Expertise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const disciplines = [{
    number: "01",
    Icon: Syringe,
    title: "Digital Strategy",
    description: "I architect comprehensive growth roadmaps that align creative vision with measurable business outcomes. From market positioning to funnel optimization, I build the foundation for scalable digital success.",
    href: "/PortfolioPage"
  }, {
    number: "02",
    Icon: CircleDot,
    title: "Content Creation",
    description: "Crafting high-impact visual and written narratives that resonate with modern audiences. I specialize in producing content that captures attention, builds community, and drives authentic engagement.",
    href: "/PortfolioPage"
  }, {
    number: "03",
    Icon: Gem,
    title: "Web Development",
    description: "Building high-performance, responsive digital experiences that convert visitors into loyal users. I combine clean code with intuitive design to ensure your brand stands out in a crowded digital landscape.",
    href: "/PortfolioPage"
  }];
  return <section data-section-id="174" id="core-expertise" ref={ref} className="bg-background text-foreground py-12 md:py-20 px-6 md:px-12 relative overflow-hidden">
      <style>{`
        @keyframes wipeFill {
          from { clip-path: inset(0 100% 0 0); }
          to { clip-path: inset(0 0 0 0); }
        }
        .craft-column:hover .craft-numeral-fill {
          animation: wipeFill 0.6s ease-out forwards;
        }
        .craft-column {
          transition: transform 0.4s ease;
        }
        .craft-column:hover {
          transform: translateY(-2px);
        }
        .craft-numeral-outline {
          -webkit-text-stroke: 2px currentColor;
          color: transparent;
        }
        .craft-numeral-fill {
          color: var(--primary);
          clip-path: inset(0 100% 0 0);
        }
      `}</style>

      <div className="max-w-7xl mx-auto">
        {}
        <div className={`mb-12 md:mb-16 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="font-mono text-xs tracking-widest uppercase mb-8 text-muted-foreground">
            03 / Core Expertise
          </div>
          <h2 className="font-default font-bold text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tighter">
            Three <span className="italic text-primary">/</span> Pillars.
          </h2>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-y-10 md:gap-y-0">
          {disciplines.map((item, i) => <div key={i} data-index={i} className={`craft-column relative px-0 md:px-8 lg:px-10 ${i > 0 ? "md:border-l md:border-border" : ""} transition-all duration-700`} style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? "translateY(0)" : "translateY(24px)",
          transitionDelay: `${i * 150}ms`
        }}>
              {}
              <div className="relative mb-10 leading-none">
                <span className="craft-numeral-outline font-default font-bold text-[8rem] leading-none block text-foreground/10">
                  {item.number}
                </span>
                <span aria-hidden="true" className="craft-numeral-fill font-default font-bold text-[8rem] leading-none absolute inset-0 block">
                  {item.number}
                </span>
              </div>

              {}
              <div className="mb-8 text-primary">
                <item.Icon className="w-12 h-12" strokeWidth={1.5} />
              </div>

              {}
              <h3 className="font-default font-bold text-4xl md:text-[2.5rem] leading-tight tracking-tight mb-6">
                {item.title}
              </h3>

              {}
              <p className="font-default text-base leading-relaxed text-muted-foreground mb-10 max-w-sm">
                {item.description}
              </p>

              {}
              <Link to={item.href} className="inline-flex items-center gap-2 font-mono text-xs tracking-widest uppercase text-primary hover:gap-3 transition-all duration-300">
                View Details
                <ArrowRight className="w-4 h-4" strokeWidth={2} />
              </Link>
            </div>)}
        </div>
      </div>
    </section>;
}